// extracted by mini-css-extract-plugin
export default {"gridRow":"CSVTab_gridRow__JT3WL","topElements":"CSVTab_topElements__ojV6R","uploadButton":"CSVTab_uploadButton__re7d9"};